import { useTheme } from "styled-components"

export const ArrowLeft = () => {
    const theme = useTheme();
    return <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 10H5L0 5L5 0H7L2 5L7 10Z" fill={theme.colors.textPrimary} fillOpacity="1"/>
    </svg>
}